import { Action } from '@ngrx/store';
import {NodeCreationResult} from "@ispm-client/modules/bpmn-modeler/models/node-creation-result";
import {TreatmentPlanSelectorResult} from "@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result";

export type NodeConfigurationResult = NodeCreationResult | TreatmentPlanSelectorResult;

export enum NodeConfigurationPanelActionTypes {
  INITIAL_DATA = '[node panel action] initial data',
  UPDATED_DATA = '[node panel action] updated data',
  CLEAR_DATA = '[node panel action] clear data'
}

export class SetInitialNodeConfigurationData implements Action {
  readonly type = NodeConfigurationPanelActionTypes.INITIAL_DATA;
  constructor(public payload: NodeConfigurationResult) { }
}

export class SetUpdatedNodeConfigurationData implements Action {
  readonly type = NodeConfigurationPanelActionTypes.UPDATED_DATA;
  constructor(public payload: NodeConfigurationResult) { }
}

export class ClearNodeConfigurationData implements Action {
  readonly type = NodeConfigurationPanelActionTypes.CLEAR_DATA;
}

export type NodeConfigurationPanelActions =
  SetInitialNodeConfigurationData |
  SetUpdatedNodeConfigurationData |
  ClearNodeConfigurationData
